import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import SideNavBar from "./component/sidebar";
import NavBar from "./component/navbar";
import Login from "./component/Auth/Login";
import DeleteAccount from "./component/Auth/DeleteAccount";
import Dashboard from "./component/Dashboard/Dashboard";
import UserData from "./component/pages/UserData";
import PaymentData from "./component/pages/PaymentData";
import WalletData from "./component/pages/WalletData";
import Settings from "./component/pages/Settings";
import Config from "./component/pages/Config";
import DiamondSettings from "./component/pages/DiamondSettings";
import TaskSettings from "./component/pages/Task";
import VisitorPlan from "./component/pages/VisitorPlan";
import BlockedUsers from "./component/pages/BlockedUsers";
import Logout from "./component/pages/Logout";


const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();

  if (!token) {
    
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const App = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [OpenPage, setOpenPage] = useState("Dashboard");

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />
        <Route path="/Delete-Account" element={<DeleteAccount />} />

        {/* Private Routes */}
        <Route
          path="*"
          element={
            <RequireAuth>
              <div className="flex h-screen bg-gray-100">
                <SideNavBar
                  isCollapsed={isSidebarCollapsed}
                  toggleSidebar={toggleSidebar}
                  setIsCollapsed={setIsSidebarCollapsed}
                  setOpenPage={setOpenPage}
                />

                <div
                  className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
                    isSidebarCollapsed ? "ml-[3.5rem]" : "ml-[13.9rem]"
                  }`}
                >
                  <NavBar title={OpenPage} />

                  <div className="flex-1 overflow-auto bg-gray-100">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/user-details" element={<UserData isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/user-details/:id" element={<UserData isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/refund-request" element={<PaymentData />} />
                      <Route path="/wallet-data" element={<WalletData />} />
                      <Route path="/config" element={<Config isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/coin-settings" element={<Settings isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/diamond-settings" element={<DiamondSettings isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/task-settings" element={<TaskSettings isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/blocked-users" element={<BlockedUsers isSidebarCollapsed={isSidebarCollapsed} />} />
                      <Route path="/logout" element={<Logout />} />
                      <Route path="/visitor-plan" element={<VisitorPlan isSidebarCollapsed={isSidebarCollapsed} />} />
                    </Routes>
                  </div>
                </div>
              </div>
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
